import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import ReporteBonificaciones from "./ReporteBonificaciones";

export default class BonificacionesClass extends Component {
    render() {
        const { proveedor } = this.props;

        return (
            <div className="mb-4 col-12">
                <Card
                    icon="reportes_activo"
                    titulo="BONIFICACIONES"
                    noBorder
                    subtitulo="Reporte"
                >
                    <ReporteBonificaciones proveedorId={proveedor} />
                </Card>
            </div>
        );
    }
}
